

export const CATEGORIES = ['Housing', 'Food', 'Entertainment']
//export const CATEGORIES = ['Housing', 'Food', 'Entertainment', 'Clothing', 'Transport', 'Other']


export const themeColors = {
    primary: '#5AFA90',
    secondary: '#5990F9',
}